import { isDefined } from "../../../utils/utils";

const INITIAL_STATE = {
    Refresh: true,
    TokenRefresh: false,
    listPatients: null,
    SearchRefresh: false,
    SearchValues: "",
    isLoading: false,
    Order: "ASC",
    PropertyOrder: "Name",
    Page: 0,
    NumberRowsPerPage: 25,
    NumberOfRecords: 0,
    PatientID: 0,
    PatientInfo: null,
    PatientEpisodes: [],
    PatientPhotoURI: null,
    PatientPhotoFileName: null,
    createPatientInProgress: false,
    stepsCreatePatient: '',
    PatientsProcessErrorMessage: null,
    getPatientsInProgress: false,
    identificationTypes: [],
    deletePatientSucess: null,
    establishmentDefault: null,
    deleteEpisodeSucess: null,
    deleteEpisodeErrorMessage: null
};

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case "PATIENTS_MANAGEMENT_SEARCH":
            if (action.error) {
                // se deu erro
                if (action.payload.status === 403 || action.payload.status === 401) {
                    // Token invalido
                    return {
                        ...state,
                        listPatients: null,
                        Refresh: false,
                        TokenRefresh: true,
                        SearchRefresh: true,
                        SearchValues: action.searchData,
                        isLoading: false,
                        establishmentDefault: null
                    };
                } else {
                    return {
                        ...state,
                        Refresh: false,
                        listPatients: [],
                        SearchRefresh: false,
                        SearchValues: "",
                        isLoading: false,
                        establishmentDefault: null
                    };
                }
            } else {
                let est = null;
                if (isDefined(action.establishments.data.result)) {
                    let aux = action.establishments.data.result
                    if (aux.length > 0) {
                        est = aux[0].rowKey
                    }
                }

                return {
                    ...state,
                    listPatients: action.payload.data.result.patients,
                    NumberOfRecords: action.payload.data.result.count,
                    Refresh: false,
                    TokenRefresh: false,
                    SearchRefresh: false,
                    SearchValues: "",
                    isLoading: false,
                    getPatientsInProgress: false,
                    identificationTypes: action.identificationTypes.data.result,
                    establishmentDefault: est
                };
            }
        case "PATIENT_INFO_MANAGEMENT":
            if (action.error) {
                if (action.payload.status === 403 || action.payload.status === 401) {
                    // Token invalido
                    return {
                        ...state,
                        Refresh: true,
                        TokenRefresh: true,
                        isLoading: false
                    };
                } else {
                    return {
                        ...state,
                        PatientID: 0,
                        PatientInfo: null,
                        isLoading: false,
                        PatientEpisodes: null
                        //PatientIDEpisode: null
                    };
                }
            } else {
                let listEpisodes = [];
                if (action.episodes.data.result.length > 0) {
                    //listEpisodes = action.episodes.data.result.sort((a, b) => parseInt(a.id) < parseInt(b.id) ? 1 : -1)
                    listEpisodes = action.episodes.data.result;
                }
                let InfoPatient = action.payload.data.result;
                if (isDefined(action.internments.data.result)) {
                    InfoPatient.internment = action.internments.data.result
                }

                return {
                    ...state,
                    PatientInfo: InfoPatient,
                    PatientEpisodes: listEpisodes,
                    isLoading: false
                };
            }
        case "URIPHOTOPATIENT_VALIDATED":
            if (action.error) {
                return {
                    ...state,
                    PatientPhotoURI: null,
                    PatientPhotoFileName: null,
                    PatientsProcessErrorMessage: "ERRO UPLOAD PHOTO"
                }
            }
            else {
                return {
                    ...state,
                    PatientPhotoURI: action.payload.uriToUpload,
                    PatientPhotoFileName: action.payload.fileName,
                    stepsCreatePatient: 'updloadPhoto',
                    createPatientInProgress: true,
                    PatientsProcessErrorMessage: ''
                }
            }
        case "CREATEPATIENT_VALIDATED":
            if (action.error) {

                if (action.payload.status === 403 || action.payload.status === 401) {
                    // Token invalido
                    return {
                        ...state,
                        Refresh: true,
                        TokenRefresh: true,
                        isLoading: false,
                        createPatientInProgress: true,
                        stepsCreatePatient: 'savePatient',
                    };
                } else {
                    let msg = "error_default"
                    if (isDefined(action.payload.data.modelErros)) {
                        if (isDefined(action.payload.data.modelErros)) {
                            let varAux = action.payload.data.modelErros;
                            JSON.stringify(varAux);
                            varAux = varAux["Internal Server Error"];
                            if (isDefined(varAux) && varAux.length > 0) {
                                if (/* varAux[0].includes("See the inner exception for details") &&  */varAux.length > 1) {
                                    msg = varAux[1]
                                } else {
                                    msg = varAux[0]
                                }
                            }
                        }
                    } else if (isDefined(action.payload.data.applicationMessages)) {
                        msg = action.payload.data.applicationMessages[0]
                        if (msg.includes('Patient alredy exists')) {
                            msg = 'ERROR_PATIENT_ALREADY_EXISTS'
                        }
                    }
                    return {
                        ...state,
                        isLoading: false,
                        createPatientInProgress: true,
                        stepsCreatePatient: 'savePatient',
                        PatientsProcessErrorMessage: msg
                    };
                }
            } else {
                return {
                    ...state,
                    isLoading: false,
                    stepsCreatePatient: 'savePatientDone',
                    PatientsProcessErrorMessage: '',
                    createPatientInProgress: true
                };
            }

        case "UPDATEPATIENT_VALIDATED":
            if (action.error) {

                if (action.payload.status === 403 || action.payload.status === 401) {
                    // Token invalido
                    return {
                        ...state,
                        Refresh: true,
                        TokenRefresh: true,
                        isLoading: false,
                        createPatientInProgress: true,
                        stepsCreatePatient: 'savePatient',
                    };
                } else {
                    let msg = "error_default"
                    if (isDefined(action.payload.data.modelErros)) {
                        if (isDefined(action.payload.data.modelErros)) {
                            let varAux = action.payload.data.modelErros;
                            JSON.stringify(varAux);
                            varAux = varAux["Internal Server Error"];
                            if (isDefined(varAux) && varAux.length > 0) {
                                if (/* varAux[0].includes("See the inner exception for details") &&  */varAux.length > 1) {
                                    msg = varAux[1]
                                } else {
                                    msg = varAux[0]
                                }
                            }
                        }
                    }
                    return {
                        ...state,
                        isLoading: false,
                        createPatientInProgress: true,
                        stepsCreatePatient: 'savePatient',
                        PatientsProcessErrorMessage: msg
                    };
                }
            } else {
                return {
                    ...state,
                    isLoading: false,
                    stepsCreatePatient: 'savePatientDone',
                    PatientsProcessErrorMessage: '',
                    createPatientInProgress: true
                };
            }
        case "DELETEPATIENT_VALIDATED":
            if (action.error) {

                if (action.payload.status === 403 || action.payload.status === 401) {
                    // Token invalido
                    return {
                        ...state,
                        Refresh: true,
                        TokenRefresh: true,
                        isLoading: false,
                        deletePatientSucess: null,
                    };
                } else {
                    let msg = "error_default"
                    /* if (isDefined(action.payload.data.modelErros)) {
                        if (isDefined(action.payload.data.modelErros)) {
                            //msg = action.payload.data.modelErros.InternalServerError
                            msg = "error_default"
                        }
                    } */
                    return {
                        ...state,
                        isLoading: false,
                        deletePatientSucess: false
                    };
                }
            } else {
                return {
                    ...state,
                    isLoading: false,
                    deletePatientSucess: true
                };
            }
        case "DELETEEPISODE_VALIDATED":
            if (action.error) {

                if (action.payload.status === 403 || action.payload.status === 401) {
                    // Token invalido
                    return {
                        ...state,
                        Refresh: true,
                        TokenRefresh: true,
                        isLoading: false,
                        deleteEpisodeSucess: null,
                    };
                } else {
                    let msg = "error_default"
                    console.log(action.payload)
                    if (isDefined(action.payload.data.modelErros)) {
                        let varAux = action.payload.data.modelErros;
                        JSON.stringify(varAux);
                        varAux = varAux["Internal Server Error"];
                        if (isDefined(varAux) && varAux.length > 1) {
                            if (varAux[1].includes("REFERENCE constraint")) {
                                msg = "error_DeleteEpisodeWithWounds"
                            }
                        }
                    }
                    return {
                        ...state,
                        isLoading: false,
                        deleteEpisodeSucess: false,
                        deleteEpisodeErrorMessage: msg
                    };
                }
            } else {
                return {
                    ...state,
                    isLoading: false,
                    deleteEpisodeSucess: true,
                    deleteEpisodeErrorMessage: null
                };
            }
        default:
            return state;
    }
}
